import { render, staticRenderFns } from "./table_dynamic.vue?vue&type=template&id=5ed74635&"
import script from "./table_dynamic.vue?vue&type=script&lang=js&"
export * from "./table_dynamic.vue?vue&type=script&lang=js&"
import style0 from "./table_dynamic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports